// extracted by mini-css-extract-plugin
module.exports = {"artwork":"style_artwork__RSkfs"};